import * as React from 'react';
//import { AppProps } from '../../components/app';
import PackageListingContainer from '../../components/package-listing-container';
import CartContainer from '../../components/cart/container';


import FiltersContainer from '../../components/filters/container';
import { AppProps } from '../../components/app';

// Resize Sensor will ensure the sticky sidebar is able to update itself when the content changes
import 'css-element-queries/src/ResizeSensor.js';
import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar.js';

interface FlexState {
    stickyInstance: any;
}

class AppView extends React.Component<AppProps, FlexState> {
    constructor(props) {
        super(props);

        this.state = {
            stickyInstance: null
        }
    }

    componentDidMount() {
        this.stickyCart();
    }

    stickyCart() {
        if (this.state) {
            if (this.state.stickyInstance == null) {
                this.setState({
                    stickyInstance: new StickySidebar('#miniCart', {
                        containerSelector: '[data-sticky-container]',
                        innerWrapperSelector: '.ace-sidebar-inner',
                        topSpacing: 135,
                        bottomSpacing: 20,
                        minWidth: 1025
                    })
                });
                // Needs to update after render is done
                window.requestAnimationFrame(() => {
                    this.state.stickyInstance.updateSticky();
                });
            }
            else {
                this.state.stickyInstance.updateSticky();
            }
        }
    }

    render() {
        return (
            <>
               
                <nav className="ace-filters-container space-top-xl stack-sm">
                    <div className="ace-block-inner">
                        <h3 className="ace-subs-filter-heading">{this.props.text.filtersTitle}</h3>
                    </div>
                    <FiltersContainer />
                </nav>
                <div className="ace-page-section ace-page-gray">
                    <section className="ace-sidebar-page" data-sticky-container>
                        <div className="ace-sidebar-main ace-subs-listing">
                            <PackageListingContainer />
                        </div>
                        <div className="ace-sidebar ace-subs-sidebar" id="miniCart">
                            <CartContainer updateStickyCart={this.stickyCart.bind(this)} />
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default AppView;